import { actions as rootActions } from '../reducers/root'
import { actions as userActions } from '../reducers/user'

export default {
  ...rootActions,
  ...userActions
}
